import { Duration } from "luxon";

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const HOURS_PER_DAY = 24;

/**
 * Formats a duration in seconds into a compact, human-readable string.
 * - Under 1 hour: mm:ss
 * - Under 1 day: h:mm:ss
 * - 1 day or more: Nd Nh Nm (avoids overflowing UI with multi-thousand hour values)
 */
export const formatDuration = (seconds: number | null): string => {
    if (!seconds) return "00:00";

    const totalSeconds = Math.max(0, Math.floor(seconds));
    const duration = Duration.fromObject({ seconds: totalSeconds });
    const totalHours = duration.as("hours");

    if (totalHours < 1) {
        return duration.toFormat("mm:ss");
    }

    if (totalHours < HOURS_PER_DAY) {
        return duration.toFormat("h:mm:ss");
    }

    const days = Math.floor(totalHours / HOURS_PER_DAY);
    const remainingHours = Math.floor(totalHours % HOURS_PER_DAY);
    const remainingMinutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);

    return `${days}d ${remainingHours}h ${remainingMinutes}m`;
};
